module.exports = __webpack_public_path__ + "static/img/dorm-bg.bac54d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sass/images/bg/dorm-bg.png
// module id = rIeQ
// module chunks = 1